import { Injectable } from '@angular/core';
import { PrintCardContentViewModel } from '../../shared/print-card-content-view-model';
import { map } from 'rxjs/operators';
import { PlainJaneCardData } from '../../../../../../../models/print-cards/plain-jane-card-data';
import { Observable } from 'rxjs';
import { PrimaryCannabinoid } from '../../../../../../../models/enum/shared/cannabinoid';
import type { PropertyPoolSorter } from '../../shared/card-data-with-property-pooling';
import { SortUtils } from '../../../../../../../utils/sort-utils';

@Injectable()
export class PlainJaneBusinessCardStackContentViewModel extends PrintCardContentViewModel {
  private readonly pinnedSecondaryPropertyMap = new Map<string, number>([
    [PrimaryCannabinoid.THC, 0],
    [PrimaryCannabinoid.CBD, 1]
  ]);

  public readonly cardData$: Observable<PlainJaneCardData>;

  public showSize$ = this.cardData$.pipe(map(cardData => cardData?.showSize()));

  public showQuantity$ = this.cardData$.pipe(map(cardData => cardData?.showQuantity()));

  protected override finalSortLambdaForCompoundProperties(): PropertyPoolSorter {
    return (a, b) => SortUtils.pinned(this.pinnedSecondaryPropertyMap, a?.title, b?.title);
  }

  protected override getSecondaryPoolOfCompoundPropertiesSortLambda(): PropertyPoolSorter {
    const defaultSort = super.getSecondaryPoolOfCompoundPropertiesSortLambda();
    return (a, b) => SortUtils.pinned(this.pinnedSecondaryPropertyMap, a?.title, b?.title) || defaultSort(a, b);
  }
}
